import { FC, useMemo } from 'react';
import { useResponsive } from '@/hooks/useResponsive';
import { observer } from 'mobx-react';
import { DesktopUploadWizzard, MobileUploadWizzard } from './components';

type Props = {
  open: boolean;
  onClose: () => void;
  onComplete: () => void;
};

export const ImageUpload: FC<Props> = observer(props => {
  const { open } = props;
  const { isMobile, isTablet } = useResponsive();

  const showMobile = useMemo(() => isMobile || isTablet, [open]);

  return showMobile ? <MobileUploadWizzard {...props} /> : <DesktopUploadWizzard {...props} />;
});
